export default __webpack_public_path__ + "static/media/clap.c7b25178.svg";